import { gql } from "graphql-tag";

export const GET_INVOICED_LETTER_COSTS = gql`
  query invoicedLetterCosts {
    invoicedLetterCosts {
      firstPageCost
      additionalPagesCost
    }
  }
`;

export const LIST = gql`
query getListById($id: ID!) {
  interestList(id: $id) {
    id
    name
    isOpen
    defaultSorting
    waitTime
    property {
      id
      name
      isDraft
      respondToEmailEnabled
      timezone
      forms {
        id
        type
        open
        display
        createInterest
      }
    }
  }
}
`;

export const GET_PROPERTY_INFO = gql`
  query getPropertyInfoById($id: ID!) {
    property(id: $id) {
      id
      name
      phone
      phoneExt
      email
      address {
        address1
        address2
        city
        state
        zip
      }
    }
  }
`;

export const UPDATE_PROPERTY_DETAILS = gql`
  mutation updatePropertyDetails($id: ID!, $data: PropertyUpdateInput!) {
    updateProperty(id: $id, data: $data) {
      id
      name
      phone
      phoneExt
      email
      address {
        address1
        address2
        city
        state
        zip
      }
    }
  }
`;
